// extracted by mini-css-extract-plugin
export default {"profile-jobs-gap":"sections_profile-jobs-gap__9Pl-7"};